/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Confirm_Copilot_Enable_BtnInputs */



/**
* | output |
* | --- |
* | "Enable" |
*
* @param {Sub_Addons_Confirm_Copilot_Enable_BtnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_copilot_enable_btn = /** @type {((inputs?: Sub_Addons_Confirm_Copilot_Enable_BtnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Copilot_Enable_BtnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivieren")
	return /** @type {LocalizedString} */ ("Enable")
});